// Dependency-free .docx → plain text extraction in the browser.
//
// A .docx is a ZIP; the text lives in word/document.xml. We parse the ZIP's
// central directory ourselves (no jszip in this bundle) and inflate the entry
// with the native DecompressionStream('deflate-raw') — available in every
// browser we target. Formatting is flattened: paragraphs → newlines, tabs →
// tabs; that's exactly what the screening agents need.

function findEocd(view) {
  // End Of Central Directory: scan back for the 0x06054b50 signature (the
  // record has a variable-length comment, max 64k).
  const min = Math.max(0, view.byteLength - 65557);
  for (let i = view.byteLength - 22; i >= min; i--) {
    if (view.getUint32(i, true) === 0x06054b50) return i;
  }
  throw new Error("not a .docx (no zip directory found)");
}

async function inflateRaw(bytes) {
  const ds = new DecompressionStream("deflate-raw");
  const stream = new Blob([bytes]).stream().pipeThrough(ds);
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

export async function docxToText(arrayBuffer) {
  const view = new DataView(arrayBuffer);
  const u8 = new Uint8Array(arrayBuffer);
  const eocd = findEocd(view);
  const count = view.getUint16(eocd + 10, true);
  let off = view.getUint32(eocd + 16, true);
  let entry = null;
  const dec = new TextDecoder();
  for (let i = 0; i < count; i++) {
    if (view.getUint32(off, true) !== 0x02014b50) break;
    const method = view.getUint16(off + 10, true);
    const compSize = view.getUint32(off + 20, true);
    const nameLen = view.getUint16(off + 28, true);
    const extraLen = view.getUint16(off + 30, true);
    const commentLen = view.getUint16(off + 32, true);
    const localOff = view.getUint32(off + 42, true);
    const name = dec.decode(u8.subarray(off + 46, off + 46 + nameLen));
    if (name === "word/document.xml") { entry = { method, compSize, localOff }; break; }
    off += 46 + nameLen + extraLen + commentLen;
  }
  if (!entry) throw new Error("no word/document.xml inside the file — is it really a .docx?");
  // Local file header: re-read name/extra lengths (extra can differ here).
  const lo = entry.localOff;
  if (view.getUint32(lo, true) !== 0x04034b50) throw new Error("corrupt .docx (bad local header)");
  const lNameLen = view.getUint16(lo + 26, true);
  const lExtraLen = view.getUint16(lo + 28, true);
  const dataStart = lo + 30 + lNameLen + lExtraLen;
  const raw = u8.subarray(dataStart, dataStart + entry.compSize);
  const xmlBytes = entry.method === 0 ? raw : await inflateRaw(raw);
  const xml = new TextDecoder().decode(xmlBytes);
  // Flatten WordprocessingML to text: paragraph ends → \n, tabs/breaks kept.
  return xml
    .replace(/<w:tab[^>]*\/>/g, "\t")
    .replace(/<w:br[^>]*\/>/g, "\n")
    .replace(/<\/w:p>/g, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

// Route any picked resume file to text: .docx via the zip path, everything
// else read as plain text.
export async function resumeFileToText(file) {
  if (/\.docx$/i.test(file.name)) return docxToText(await file.arrayBuffer());
  return file.text();
}
